import { render, staticRenderFns } from "./CardContentAssociationAndFondation.vue?vue&type=template&id=54a3e2f6&scoped=true&"
import script from "./CardContentAssociationAndFondation.vue?vue&type=script&lang=js&"
export * from "./CardContentAssociationAndFondation.vue?vue&type=script&lang=js&"
import style0 from "./CardContentAssociationAndFondation.vue?vue&type=style&index=0&id=54a3e2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3e2f6",
  null
  
)

export default component.exports